window.addEventListener('load', function() {
  $('.product-image-slick').slick({
    dots: true,
    arrows: true,
    centerPadding: "0px",
    slidesToShow: 1,
    infinite: true,
    rtl: true,
    prevArrow: `<button class="product-slick-prev arrow-buttons"><img src="https://cdn.shopify.com/s/files/1/0519/4055/6973/files/arrow-right-333-svgrepo-com_430x.svg?v=1685196688"></button>`,
    nextArrow: `<button class="product-slick-next arrow-buttons"><img src="https://cdn.shopify.com/s/files/1/0519/4055/6973/files/arrow-right-333-svgrepo-com_430x.svg?v=1685196688"></button>`,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false,
        dots: true,
      }
    }]
  });
});